import { render, staticRenderFns } from "./FundsAddedNotif.vue?vue&type=template&id=b8d21a0c&"
import script from "./FundsAddedNotif.vue?vue&type=script&lang=js&"
export * from "./FundsAddedNotif.vue?vue&type=script&lang=js&"
import style0 from "./FundsAddedNotif.vue?vue&type=style&index=0&id=b8d21a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports